export default {
  FETCH_STORY_EMAIL_TEMPLATES_REQUEST: 'FETCH_STORY_EMAIL_TEMPLATES_REQUEST',
  FETCH_STORY_EMAIL_TEMPLATES_SUCCESS: 'FETCH_STORY_EMAIL_TEMPLATES_SUCCESS',
  FETCH_STORY_EMAIL_TEMPLATES_FAILURE: 'FETCH_STORY_EMAIL_TEMPLATES_FAILURE',
  UPDATE_STORY_EMAIL_TEMPLATE: 'UPDATE_STORY_EMAIL_TEMPLATE'
}
